import Box from '@mui/material/Box';
import { type SystemStyleObject } from '@mui/system';
import range from 'lodash/range';
import React, { FC } from 'react';

import { LabwareSlotItem } from './LabwareSlotItem';

import type { LabwareSlotData } from '.';

interface Props {
  sx?: SystemStyleObject;
  columns: number;
  rows: number;
  labwareSlotData: LabwareSlotData;
}

export const GridDeckVisualization: FC<Props> = (props) => {
  const { columns, rows, labwareSlotData } = props;

  const slotHeightRem = 4;

  return (
    <Box
      sx={[
        {
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: '0.5rem',
          backgroundColor: 'grey.100',
          padding: '0.5rem',
          borderWidth: '3px',
          borderStyle: 'solid',
          borderColor: 'grey.300',
          borderRadius: '5px',
        },
        props.sx ?? null,
      ]}
    >
      {range(rows * columns).map((flatIndex) => {
        const slot = flatIndex + 1;
        const labwareData = labwareSlotData.find(
          (item) => slot === item.slot
        )?.data;

        return (
          <LabwareSlotItem
            colorIndex={labwareData?.colorIndex}
            nickname={labwareData?.labwareName}
            key={slot}
            slot={slot}
            slotHeightRem={slotHeightRem}
            showSlotLabel
          />
        );
      })}
    </Box>
  );
};
